<template>
  <div class="box">
    <v-layout justify-end>
      <ExportAccount :headers="headers" :accountType="'creditNote'" />
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="accountList"
      class="elevation-1 mt-2"
      :mobile-breakpoint="0"
      :options.sync="options"
      :items-per-page="25"
      :server-items-length="totalItemsCount"
      :loading="loading"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:[`item.siNo`]="{ item }">
        {{
          accountList
            .map(function(x) {
              return x._id;
            })
            .indexOf(item._id) +
            1 +
            options.itemsPerPage * (options.page - 1)
        }}
      </template>
      <template v-slot:[`item.customerName`]="{ item }">
        <router-link
          v-if="item.user"
          :to="{
            name: 'CustomerDetails',
            query: { customerId: item.customer }
          }"
          class="mx-auto"
        >
          {{ item.user.firstnameEn }}
        </router-link>
      </template>
      <template v-slot:[`item.contact`]="{ item }">
        <div v-if="item.user">
          {{ item.user.phone }}
        </div>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ dateFormat(new Date(parseInt(item.createdAt))) }}
      </template>
      <template v-slot:[`item.amount`]="{ item }">
        {{ item.amount }}
      </template>
      <template v-slot:[`item.total`]="{ item }">
        {{ item.total }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import moment from "moment";
import ExportAccount from "../components/ExportAccount.vue";
export default {
  components: {
    ExportAccount
  },
  data: () => ({
    accountList: [],
    loading: true,
    headers: [
      {
        text: "Si No",
        value: "siNo",
        sortable: false
      },
      { text: "Customer Name", value: "customerName" },
      { text: "Contact", value: "contact", sortable: false },
      { text: "Date and Time", value: "date" },
      { text: "Amount", value: "amount" },
      { text: "Total ", value: "total" }
    ],
    totalItemsCount: 0,
    variables: {
      limit: 25,
      skip: 0
    },
    options: {
      itemsPerPage: 25,
      page: 1
    }
  }),
  watch: {
    options: {
      handler() {
        if (!this.loading) {
          this.variables.limit = this.options.itemsPerPage;
          this.variables.skip =
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage;
          (this.variables.sortDesc = this.options.sortDesc
            ? this.options.sortDesc[0]
            : ""),
            (this.variables.sortBy = this.options.sortBy
              ? this.options.sortBy[0]
              : ""),
            this.getAllCreditNoteTransactions();
        }
      },
      deep: true
    }
  },
  created() {
    this.getAllCreditNoteTransactions();
  },
  methods: {
    dateFormat(date) {
      return moment(date, "MM-DD-YYYY").format("DD-MM-YYYY, h:mm:ss a");
    },
    getAllCreditNoteTransactions() {
      this.$apollo
        .query({
          query: require("../api/getAllCreditNoteTransaction.graphql"),
          variables: this.variables
        })
        .then(data => {
          if (data.data.getAllCreditNoteTransactions) {
            this.accountList =
              data.data.getAllCreditNoteTransactions.transactionList;
            this.totalItemsCount =
              data.data.getAllCreditNoteTransactions.totalCount;
            console.log(this.accountList.length);
          }
          this.loading = false;
        });
    }
  }
};
</script>
<style>
.box {
  background-color: #e5e5e5;
}
</style>
